import {
  PlusOutlined,
  EditOutlined,
  DeleteOutlined,
  // EllipsisOutlined, // N'est plus utilisé avec les boutons individuels
} from "@ant-design/icons";
import {
  Button,
  Modal as AntModal,
  Table,
  Tooltip,
} from "antd"; // Tooltip a été ajouté ici
import axios from "axios";
import React, { useEffect, useState } from "react";
import Footer from "../../../components/Footer";
import NavBar from "../../../components/NavBar";
import SideBar from "../../../components/SideBar";
import { API_URL, TOKEN } from "../../../variables/constants";
import AddTypeProfil from "./AddTypeProfil";
import { toast } from "react-toastify";
import ActionDropdown from "../../production/components/ActionDropdown";

const TypeProfils = () => {
  const [typeProfils, setTypeProfils] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [selectedTypeProfil, setSelectedTypeProfil] = useState(null);
  const [loadingTable, setLoadingTable] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize] = useState(10);

  const handleShow = (edit = false, profile = null) => {
    setShowModal(true);
    setEditMode(edit);
    setSelectedTypeProfil(profile);
  };

  const handleClose = () => {
    setShowModal(false);
    setEditMode(false);
    setSelectedTypeProfil(null);
  };

 
  const sortProfiles = (profiles) =>
    [...profiles].sort((a, b) => b.parametreId - a.parametreId);

  const fetchTypeProfils = () => {
    setLoadingTable(true);
    axios
      .get(`${API_URL}/api/parametre/type/TYPE_PROFIL`, {
        headers: {
          Authorization: `Bearer ${TOKEN}`,
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        // Appliquer le tri initialement
        setTypeProfils(sortProfiles(res.data));
      })
      .catch((err) => {
        console.error("Error fetching profiles:", err);
        toast.error("Erreur lors du chargement des types de profil.");
      })
      .finally(() => setLoadingTable(false));
  };

  useEffect(() => {
    fetchTypeProfils();
  }, []);

  const handleSaveSuccess = (savedTypeProfil) => {
    let updatedList;
    if (editMode) {
      //  Pour la MODIFICATION :
      // 1. Filtrer l'élément original (non modifié)
      const otherProfiles = typeProfils.filter(
        (tp) => tp.parametreId !== savedTypeProfil.parametreId
      );
      // 2. Placer l'élément modifié en première position
      // 3. Appliquer le tri aux AUTRES éléments, puis combiner.
      // Cela garantit que l'élément modifié est en haut, et le reste est trié par ID.
      updatedList = [savedTypeProfil, ...sortProfiles(otherProfiles)];
    } else {
      // Pour l'AJOUT :
      // 1. Placer le nouvel élément en première position
      // 2. Appliquer le tri aux éléments existants, puis combiner.
      updatedList = [savedTypeProfil, ...sortProfiles(typeProfils)];
    }

    setTypeProfils(updatedList); // Mettre à jour l'état avec la nouvelle liste triée et l'élément en tête
    handleClose();
    setCurrentPage(1); // Retourne à la première page pour que l'utilisateur voie l'élément en haut
  };

  const handleDeleteTypeProfil = (parametreId) => {
    AntModal.confirm({
      title: "Êtes-vous sûr de vouloir supprimer ce profil ?",
      content: "Cette action est irréversible",
      okText: "Oui",
      okType: "danger",
      cancelText: "Annuler",
      onOk: () => {
        axios
          .delete(`${API_URL}/api/parametre/${parametreId}`, {
            headers: { Authorization: `Bearer ${TOKEN}` },
          })
          .then(() => {
            const updatedList = typeProfils.filter(
              (tp) => tp.parametreId !== parametreId
            );
            // Appliquer le tri après la suppression
            setTypeProfils(sortProfiles(updatedList));
            toast.success("Type de profil supprimé avec succès.");
          })
          .catch((err) => {
            console.error("Error deleting profile:", err);
            toast.error("Erreur lors de la suppression du profil.");
          });
      },
    });
  };

  const columns = [
    {
      title: "Nom",
      dataIndex: "libelleParametre",
      key: "libelleParametre",
      sorter: (a, b) => a.libelleParametre.localeCompare(b.libelleParametre),
    },
    {
      title: "Actions",
      key: "actions",
      render: (_, record) => (
        <div style={{ display: "flex", gap: "10px" }}>
          <ActionDropdown
                              actions={[
                                {
                                  key: "edit",
                                  label: "Modifier",
                                  icon: <i className="bx bx-edit-alt" />,
                                  onClick: () => handleShow(true, record),
                                },
                                {
                                  key: "delete",
                                  label: "Supprimer",
                                  icon: <i className="bx bx-trash" />,
                                  danger: true,
                                  onClick: () => handleDeleteTypeProfil(record.parametreId),
                                },
                              ]}
                            />
        </div>
      ),
    },
  ];

  return (
    <div className="layout-wrapper layout-content-navbar">
      <div className="layout-container">
        <SideBar currentMenu="AUTRES_PARAMETRES" />
        <div className="layout-page">
          <NavBar />
          <div className="content-wrapper">
            <div className="container-xxl flex-grow-1 container-p-y">
              <Button
                type="primary"
                icon={<PlusOutlined />}
                style={{ marginBottom: 16 }}
                onClick={() => handleShow()}
              >
                Ajouter un nouveau profil
              </Button>

              <div className="card">
                <h5 className="card-header">Les différents types de profil</h5>
                <div className="table-responsive text-nowrap">
                  <Table
                    columns={columns}
                    dataSource={typeProfils} // Source de données avec l'ordre géré par handleSaveSuccess
                    rowKey="parametreId"
                    loading={loadingTable}
                    pagination={{
                      pageSize,
                      current: currentPage,
                      total: typeProfils.length,
                      onChange: (page) => setCurrentPage(page),
                      showSizeChanger: true,
                      showTotal: (total, range) =>
                        `${range[0]}-${range[1]} sur ${total} éléments`,
                    }}
                    locale={{ emptyText: "Aucun type de profil trouvé" }}
                  />
                </div>
              </div>
            </div>
            <Footer />
          </div>
        </div>
      </div>

      <AddTypeProfil
        show={showModal}
        handleClose={handleClose}
        editMode={editMode}
        selectedTypeProfil={selectedTypeProfil}
        typeProfils={typeProfils}
        onSaveSuccess={handleSaveSuccess}
      />
    </div>
  );
};

export default TypeProfils;